import React, { useContext, useEffect, useState } from "react";
import "./AddressModal.css";
import { Modal } from "react-bootstrap";
import { Context } from "../../../utils/context";

const AddressModal = (props) => {
  const { getData, IMG_URL } = useContext(Context);
  const [data, setData] = useState({});
  const getDataAll = async () => {
    const response = await getData(`/order/${props?.id}`);
    await setData(response?.data?.data);
  };

  useEffect(() => {
    getDataAll();
  }, [props.id]);

  const imageUrl =
    data?.product_variant?.product_images?.[0]?.image ||
    data?.product_multiple_variant?.product_multi_varient_images?.[0]?.image;

  return (
    <div className="AddressModal_div">
      <Modal
        className="AddressModal"
        {...props}
        size="lg
          "
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header closeButton>Order Details</Modal.Header>
        <Modal.Body>
          <div className="address_form_holder">
            <div className="row">
              <div className="col-lg-3">
                <p className="label_text">Product Name :-</p>
              </div>
              <div className="col-lg-9">
                <p className="value_text">{data?.product?.name}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3">
                <p className="label_text">Product Varient Name :-</p>
              </div>
              <div className="col-lg-9">
                <p className="value_text">
                  {data?.product_variant?.v_name ||
                    data?.product_multiple_variant?.varient_sub_name}
                </p>
              </div>
            </div>{" "}
            <div className="row">
              <div className="col-lg-3">
                <p className="label_text">Product Quantity :-</p>
              </div>
              <div className="col-lg-9">
                <p className="value_text">{data?.quantity}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3">
                <p className="label_text">Amount :-</p>
              </div>
              <div className="col-lg-9">
                <p className="value_text">
                  ₹{" "}
                  {data?.product_variant
                    ? Number(data.product_variant?.mrp * data?.quantity) +
                      Number(data?.product?.delivery_charges)
                    : Number(
                        data?.product_multiple_variant?.mrp * data?.quantity
                      ) + Number(data?.product?.delivery_charges)}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3">
                <p className="label_text">Payment Status :-</p>
              </div>
              <div className="col-lg-9">
                <p className="value_text">
                  {data?.payment_status == 1 ? "Paid" : "Unpaid"}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3">
                <p className="label_text">Image :-</p>
              </div>
              <div className="col-lg-9">
                <p className="value_text">
                  {imageUrl && (
                    <img
                      src={`${IMG_URL}${imageUrl}`}
                      alt="Image"
                      width="100"
                      height="100"
                    />
                  )}
                </p>
              </div>
            </div>
            <hr></hr>
            <div className="row">
              <div className="col-lg-3">
                <p className="label_text">Country :-</p>
              </div>
              <div className="col-lg-9">
                <p className="value_text">
                  {data?.order?.users_address?.country?.name}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3">
                <p className="label_text">State :-</p>
              </div>
              <div className="col-lg-9">
                <p className="value_text">
                  {" "}
                  {data?.order?.users_address?.state?.name}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3">
                <p className="label_text">City :-</p>
              </div>
              <div className="col-lg-9">
                <p className="value_text">
                  {" "}
                  {data?.order?.users_address?.city?.name}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3">
                <p className="label_text">Pincode :-</p>
              </div>
              <div className="col-lg-9">
                <p className="value_text">
                  {data?.order?.users_address?.pincode?.name}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3">
                <p className="label_text">Address Type :-</p>
              </div>
              <div className="col-lg-9">
                <p className="value_text">
                  {data?.order?.users_address?.address_type}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3">
                <p className="label_text">Flat House Or Building :-</p>
              </div>
              <div className="col-lg-9">
                <p className="value_text">
                  {data?.order?.users_address?.flat_home_bldg}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3">
                <p className="label_text">Colony Street Or Lankmark:-</p>
              </div>
              <div className="col-lg-9">
                <p className="value_text">
                  {data?.order?.users_address?.col_land_strt}
                </p>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddressModal;
